import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { Box, Button, Typography } from '@material-ui/core';
import FormattedTranslation from '@htmniseko/htm-ui/Intl/FormattedTranslationMui';
import PageTitle from 'components/PageTitle';
import usePushHome from 'hooks/router/usePushHome';

const NotFound = () => {
  const { formatMessage } = useIntl();
  const pushHome = usePushHome();
  return (
    <>
      <Helmet title={formatMessage({ id: 'page.notFound.helmet' })} />
      <PageTitle align="left" size="medium">
        <FormattedTranslation id="page.notFound.title" />
      </PageTitle>
      <Typography variant="body1">
        <FormattedTranslation id="page.notFound.description" />
      </Typography>
      <Box textAlign="right">
        <Button
          variant="contained"
          onClick={() => pushHome()}
        >
          <FormattedTranslation id="page.notFound.button.continue" />
        </Button>
      </Box>
    </>
  );
};

export default NotFound;
